// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.8.3
//   protoc               v6.33.1
// source: ediphor.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "PB";

/** Measurement channels */
export const CHAN = {
  /** OPEN - Nothing connected, measures stray path alone */
  OPEN: "OPEN",
  CH1: "CH1",
  CH2: "CH2",
  CH3: "CH3",
  CH4: "CH4",
  /** CAL - On-board calibration resistor, measured like any channel */
  CAL: "CAL",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type CHAN = typeof CHAN[keyof typeof CHAN];

export namespace CHAN {
  export type OPEN = typeof CHAN.OPEN;
  export type CH1 = typeof CHAN.CH1;
  export type CH2 = typeof CHAN.CH2;
  export type CH3 = typeof CHAN.CH3;
  export type CH4 = typeof CHAN.CH4;
  export type CAL = typeof CHAN.CAL;
  export type UNRECOGNIZED = typeof CHAN.UNRECOGNIZED;
}

export function cHANFromJSON(object: any): CHAN {
  switch (object) {
    case 0:
    case "OPEN":
      return CHAN.OPEN;
    case 1:
    case "CH1":
      return CHAN.CH1;
    case 2:
    case "CH2":
      return CHAN.CH2;
    case 3:
    case "CH3":
      return CHAN.CH3;
    case 4:
    case "CH4":
      return CHAN.CH4;
    case 5:
    case "CAL":
      return CHAN.CAL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CHAN.UNRECOGNIZED;
  }
}

export function cHANToJSON(object: CHAN): string {
  switch (object) {
    case CHAN.OPEN:
      return "OPEN";
    case CHAN.CH1:
      return "CH1";
    case CHAN.CH2:
      return "CH2";
    case CHAN.CH3:
      return "CH3";
    case CHAN.CH4:
      return "CH4";
    case CHAN.CAL:
      return "CAL";
    case CHAN.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function cHANToNumber(object: CHAN): number {
  switch (object) {
    case CHAN.OPEN:
      return 0;
    case CHAN.CH1:
      return 1;
    case CHAN.CH2:
      return 2;
    case CHAN.CH3:
      return 3;
    case CHAN.CH4:
      return 4;
    case CHAN.CAL:
      return 5;
    case CHAN.UNRECOGNIZED:
    default:
      return -1;
  }
}

/** TIA feedback resistor, pick one close to impedance magnitude */
export const TIA = {
  Resistor_200Ohm: "Resistor_200Ohm",
  Resistor_1kOhm: "Resistor_1kOhm",
  Resistor_5kOhm: "Resistor_5kOhm",
  Resistor_10kOhm: "Resistor_10kOhm",
  Resistor_20kOhm: "Resistor_20kOhm",
  Resistor_40kOhm: "Resistor_40kOhm",
  Resistor_80kOhm: "Resistor_80kOhm",
  Resistor_160kOhm: "Resistor_160kOhm",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type TIA = typeof TIA[keyof typeof TIA];

export namespace TIA {
  export type Resistor_200Ohm = typeof TIA.Resistor_200Ohm;
  export type Resistor_1kOhm = typeof TIA.Resistor_1kOhm;
  export type Resistor_5kOhm = typeof TIA.Resistor_5kOhm;
  export type Resistor_10kOhm = typeof TIA.Resistor_10kOhm;
  export type Resistor_20kOhm = typeof TIA.Resistor_20kOhm;
  export type Resistor_40kOhm = typeof TIA.Resistor_40kOhm;
  export type Resistor_80kOhm = typeof TIA.Resistor_80kOhm;
  export type Resistor_160kOhm = typeof TIA.Resistor_160kOhm;
  export type UNRECOGNIZED = typeof TIA.UNRECOGNIZED;
}

export function tIAFromJSON(object: any): TIA {
  switch (object) {
    case 0:
    case "Resistor_200Ohm":
      return TIA.Resistor_200Ohm;
    case 1:
    case "Resistor_1kOhm":
      return TIA.Resistor_1kOhm;
    case 2:
    case "Resistor_5kOhm":
      return TIA.Resistor_5kOhm;
    case 3:
    case "Resistor_10kOhm":
      return TIA.Resistor_10kOhm;
    case 4:
    case "Resistor_20kOhm":
      return TIA.Resistor_20kOhm;
    case 5:
    case "Resistor_40kOhm":
      return TIA.Resistor_40kOhm;
    case 6:
    case "Resistor_80kOhm":
      return TIA.Resistor_80kOhm;
    case 7:
    case "Resistor_160kOhm":
      return TIA.Resistor_160kOhm;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TIA.UNRECOGNIZED;
  }
}

export function tIAToJSON(object: TIA): string {
  switch (object) {
    case TIA.Resistor_200Ohm:
      return "Resistor_200Ohm";
    case TIA.Resistor_1kOhm:
      return "Resistor_1kOhm";
    case TIA.Resistor_5kOhm:
      return "Resistor_5kOhm";
    case TIA.Resistor_10kOhm:
      return "Resistor_10kOhm";
    case TIA.Resistor_20kOhm:
      return "Resistor_20kOhm";
    case TIA.Resistor_40kOhm:
      return "Resistor_40kOhm";
    case TIA.Resistor_80kOhm:
      return "Resistor_80kOhm";
    case TIA.Resistor_160kOhm:
      return "Resistor_160kOhm";
    case TIA.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function tIAToNumber(object: TIA): number {
  switch (object) {
    case TIA.Resistor_200Ohm:
      return 0;
    case TIA.Resistor_1kOhm:
      return 1;
    case TIA.Resistor_5kOhm:
      return 2;
    case TIA.Resistor_10kOhm:
      return 3;
    case TIA.Resistor_20kOhm:
      return 4;
    case TIA.Resistor_40kOhm:
      return 5;
    case TIA.Resistor_80kOhm:
      return 6;
    case TIA.Resistor_160kOhm:
      return 7;
    case TIA.UNRECOGNIZED:
    default:
      return -1;
  }
}

/** ADC gain, raise as input amplitude drops */
export const ADC = {
  Gain_1: "Gain_1",
  Gain_1P5: "Gain_1P5",
  Gain_2: "Gain_2",
  Gain_4: "Gain_4",
  Gain_9: "Gain_9",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type ADC = typeof ADC[keyof typeof ADC];

export namespace ADC {
  export type Gain_1 = typeof ADC.Gain_1;
  export type Gain_1P5 = typeof ADC.Gain_1P5;
  export type Gain_2 = typeof ADC.Gain_2;
  export type Gain_4 = typeof ADC.Gain_4;
  export type Gain_9 = typeof ADC.Gain_9;
  export type UNRECOGNIZED = typeof ADC.UNRECOGNIZED;
}

export function aDCFromJSON(object: any): ADC {
  switch (object) {
    case 0:
    case "Gain_1":
      return ADC.Gain_1;
    case 1:
    case "Gain_1P5":
      return ADC.Gain_1P5;
    case 2:
    case "Gain_2":
      return ADC.Gain_2;
    case 3:
    case "Gain_4":
      return ADC.Gain_4;
    case 4:
    case "Gain_9":
      return ADC.Gain_9;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ADC.UNRECOGNIZED;
  }
}

export function aDCToJSON(object: ADC): string {
  switch (object) {
    case ADC.Gain_1:
      return "Gain_1";
    case ADC.Gain_1P5:
      return "Gain_1P5";
    case ADC.Gain_2:
      return "Gain_2";
    case ADC.Gain_4:
      return "Gain_4";
    case ADC.Gain_9:
      return "Gain_9";
    case ADC.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function aDCToNumber(object: ADC): number {
  switch (object) {
    case ADC.Gain_1:
      return 0;
    case ADC.Gain_1P5:
      return 1;
    case ADC.Gain_2:
      return 2;
    case ADC.Gain_4:
      return 3;
    case ADC.Gain_9:
      return 4;
    case ADC.UNRECOGNIZED:
    default:
      return -1;
  }
}

/**
 * When reference resistor is measured. Every reading ratios to it. Reference pass opens
 * cell switches, so 'REUSE' keeps cells connected across sweeps.
 */
export const Reference = {
  /** BEFORE - Before channels, in this sweep */
  BEFORE: "BEFORE",
  /** AFTER - After channels, in this sweep */
  AFTER: "AFTER",
  /** REUSE - Reference of previous sweep with same path settings, kept in RAM; refused without one */
  REUSE: "REUSE",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type Reference = typeof Reference[keyof typeof Reference];

export namespace Reference {
  export type BEFORE = typeof Reference.BEFORE;
  export type AFTER = typeof Reference.AFTER;
  export type REUSE = typeof Reference.REUSE;
  export type UNRECOGNIZED = typeof Reference.UNRECOGNIZED;
}

export function referenceFromJSON(object: any): Reference {
  switch (object) {
    case 0:
    case "BEFORE":
      return Reference.BEFORE;
    case 1:
    case "AFTER":
      return Reference.AFTER;
    case 2:
    case "REUSE":
      return Reference.REUSE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Reference.UNRECOGNIZED;
  }
}

export function referenceToJSON(object: Reference): string {
  switch (object) {
    case Reference.BEFORE:
      return "BEFORE";
    case Reference.AFTER:
      return "AFTER";
    case Reference.REUSE:
      return "REUSE";
    case Reference.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function referenceToNumber(object: Reference): number {
  switch (object) {
    case Reference.BEFORE:
      return 0;
    case Reference.AFTER:
      return 1;
    case Reference.REUSE:
      return 2;
    case Reference.UNRECOGNIZED:
    default:
      return -1;
  }
}

/** What device does with request */
export const Triggers = {
  /** NONE - Nothing, returns current state */
  NONE: "NONE",
  /** SLEEP - Enter sleep mode */
  SLEEP: "SLEEP",
  /** REBOOT - Reset device */
  REBOOT: "REBOOT",
  /** BLINK - Flash LED to locate device */
  BLINK: "BLINK",
  /** MEASURE_START - Start a measurement */
  MEASURE_START: "MEASURE_START",
  /** MEASURE_ABORT - Stop running measurement, points taken so far are kept */
  MEASURE_ABORT: "MEASURE_ABORT",
  /** MEASURE_RESULT - Return last measurement */
  MEASURE_RESULT: "MEASURE_RESULT",
  /** UPDATE_BEGIN - Open firmware transfer, 'update' names image size and crc */
  UPDATE_BEGIN: "UPDATE_BEGIN",
  /** UPDATE_WRITE - Next bytes of image, 'update' carries offset and data */
  UPDATE_WRITE: "UPDATE_WRITE",
  /** UPDATE_END - Seal image for bootloader, device reboots after reply */
  UPDATE_END: "UPDATE_END",
  /** UPDATE_ABORT - Drop open transfer */
  UPDATE_ABORT: "UPDATE_ABORT",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type Triggers = typeof Triggers[keyof typeof Triggers];

export namespace Triggers {
  export type NONE = typeof Triggers.NONE;
  export type SLEEP = typeof Triggers.SLEEP;
  export type REBOOT = typeof Triggers.REBOOT;
  export type BLINK = typeof Triggers.BLINK;
  export type MEASURE_START = typeof Triggers.MEASURE_START;
  export type MEASURE_ABORT = typeof Triggers.MEASURE_ABORT;
  export type MEASURE_RESULT = typeof Triggers.MEASURE_RESULT;
  export type UPDATE_BEGIN = typeof Triggers.UPDATE_BEGIN;
  export type UPDATE_WRITE = typeof Triggers.UPDATE_WRITE;
  export type UPDATE_END = typeof Triggers.UPDATE_END;
  export type UPDATE_ABORT = typeof Triggers.UPDATE_ABORT;
  export type UNRECOGNIZED = typeof Triggers.UNRECOGNIZED;
}

export function triggersFromJSON(object: any): Triggers {
  switch (object) {
    case 0:
    case "NONE":
      return Triggers.NONE;
    case 1:
    case "SLEEP":
      return Triggers.SLEEP;
    case 2:
    case "REBOOT":
      return Triggers.REBOOT;
    case 3:
    case "BLINK":
      return Triggers.BLINK;
    case 4:
    case "MEASURE_START":
      return Triggers.MEASURE_START;
    case 5:
    case "MEASURE_ABORT":
      return Triggers.MEASURE_ABORT;
    case 6:
    case "MEASURE_RESULT":
      return Triggers.MEASURE_RESULT;
    case 7:
    case "UPDATE_BEGIN":
      return Triggers.UPDATE_BEGIN;
    case 8:
    case "UPDATE_WRITE":
      return Triggers.UPDATE_WRITE;
    case 9:
    case "UPDATE_END":
      return Triggers.UPDATE_END;
    case 10:
    case "UPDATE_ABORT":
      return Triggers.UPDATE_ABORT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Triggers.UNRECOGNIZED;
  }
}

export function triggersToJSON(object: Triggers): string {
  switch (object) {
    case Triggers.NONE:
      return "NONE";
    case Triggers.SLEEP:
      return "SLEEP";
    case Triggers.REBOOT:
      return "REBOOT";
    case Triggers.BLINK:
      return "BLINK";
    case Triggers.MEASURE_START:
      return "MEASURE_START";
    case Triggers.MEASURE_ABORT:
      return "MEASURE_ABORT";
    case Triggers.MEASURE_RESULT:
      return "MEASURE_RESULT";
    case Triggers.UPDATE_BEGIN:
      return "UPDATE_BEGIN";
    case Triggers.UPDATE_WRITE:
      return "UPDATE_WRITE";
    case Triggers.UPDATE_END:
      return "UPDATE_END";
    case Triggers.UPDATE_ABORT:
      return "UPDATE_ABORT";
    case Triggers.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function triggersToNumber(object: Triggers): number {
  switch (object) {
    case Triggers.NONE:
      return 0;
    case Triggers.SLEEP:
      return 1;
    case Triggers.REBOOT:
      return 2;
    case Triggers.BLINK:
      return 3;
    case Triggers.MEASURE_START:
      return 4;
    case Triggers.MEASURE_ABORT:
      return 5;
    case Triggers.MEASURE_RESULT:
      return 6;
    case Triggers.UPDATE_BEGIN:
      return 7;
    case Triggers.UPDATE_WRITE:
      return 8;
    case Triggers.UPDATE_END:
      return 9;
    case Triggers.UPDATE_ABORT:
      return 10;
    case Triggers.UNRECOGNIZED:
    default:
      return -1;
  }
}

/** Charger state */
export const PowerState = {
  UNKNOWN: "UNKNOWN",
  /** BATTERY - Running on battery */
  BATTERY: "BATTERY",
  /** CHARGING - Preconditioning | Constant Current | Constant Voltage */
  CHARGING: "CHARGING",
  /** STANDBY - Charge complete */
  STANDBY: "STANDBY",
  /** FAULT - Temperature or timer fault */
  FAULT: "FAULT",
  /** NO_BATTERY - Battery missing or damaged */
  NO_BATTERY: "NO_BATTERY",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type PowerState = typeof PowerState[keyof typeof PowerState];

export namespace PowerState {
  export type UNKNOWN = typeof PowerState.UNKNOWN;
  export type BATTERY = typeof PowerState.BATTERY;
  export type CHARGING = typeof PowerState.CHARGING;
  export type STANDBY = typeof PowerState.STANDBY;
  export type FAULT = typeof PowerState.FAULT;
  export type NO_BATTERY = typeof PowerState.NO_BATTERY;
  export type UNRECOGNIZED = typeof PowerState.UNRECOGNIZED;
}

export function powerStateFromJSON(object: any): PowerState {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return PowerState.UNKNOWN;
    case 1:
    case "BATTERY":
      return PowerState.BATTERY;
    case 2:
    case "CHARGING":
      return PowerState.CHARGING;
    case 3:
    case "STANDBY":
      return PowerState.STANDBY;
    case 4:
    case "FAULT":
      return PowerState.FAULT;
    case 5:
    case "NO_BATTERY":
      return PowerState.NO_BATTERY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PowerState.UNRECOGNIZED;
  }
}

export function powerStateToJSON(object: PowerState): string {
  switch (object) {
    case PowerState.UNKNOWN:
      return "UNKNOWN";
    case PowerState.BATTERY:
      return "BATTERY";
    case PowerState.CHARGING:
      return "CHARGING";
    case PowerState.STANDBY:
      return "STANDBY";
    case PowerState.FAULT:
      return "FAULT";
    case PowerState.NO_BATTERY:
      return "NO_BATTERY";
    case PowerState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function powerStateToNumber(object: PowerState): number {
  switch (object) {
    case PowerState.UNKNOWN:
      return 0;
    case PowerState.BATTERY:
      return 1;
    case PowerState.CHARGING:
      return 2;
    case PowerState.STANDBY:
      return 3;
    case PowerState.FAULT:
      return 4;
    case PowerState.NO_BATTERY:
      return 5;
    case PowerState.UNRECOGNIZED:
    default:
      return -1;
  }
}

/** Electrode cartridge code read at connector */
export const ElectrodeDetect = {
  /** NC - Electrode not connected */
  NC: "NC",
  CODE_1: "CODE_1",
  CODE_2: "CODE_2",
  CODE_3: "CODE_3",
  CODE_4: "CODE_4",
  CODE_5: "CODE_5",
  CODE_6: "CODE_6",
  CODE_7: "CODE_7",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type ElectrodeDetect = typeof ElectrodeDetect[keyof typeof ElectrodeDetect];

export namespace ElectrodeDetect {
  export type NC = typeof ElectrodeDetect.NC;
  export type CODE_1 = typeof ElectrodeDetect.CODE_1;
  export type CODE_2 = typeof ElectrodeDetect.CODE_2;
  export type CODE_3 = typeof ElectrodeDetect.CODE_3;
  export type CODE_4 = typeof ElectrodeDetect.CODE_4;
  export type CODE_5 = typeof ElectrodeDetect.CODE_5;
  export type CODE_6 = typeof ElectrodeDetect.CODE_6;
  export type CODE_7 = typeof ElectrodeDetect.CODE_7;
  export type UNRECOGNIZED = typeof ElectrodeDetect.UNRECOGNIZED;
}

export function electrodeDetectFromJSON(object: any): ElectrodeDetect {
  switch (object) {
    case 0:
    case "NC":
      return ElectrodeDetect.NC;
    case 1:
    case "CODE_1":
      return ElectrodeDetect.CODE_1;
    case 2:
    case "CODE_2":
      return ElectrodeDetect.CODE_2;
    case 3:
    case "CODE_3":
      return ElectrodeDetect.CODE_3;
    case 4:
    case "CODE_4":
      return ElectrodeDetect.CODE_4;
    case 5:
    case "CODE_5":
      return ElectrodeDetect.CODE_5;
    case 6:
    case "CODE_6":
      return ElectrodeDetect.CODE_6;
    case 7:
    case "CODE_7":
      return ElectrodeDetect.CODE_7;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ElectrodeDetect.UNRECOGNIZED;
  }
}

export function electrodeDetectToJSON(object: ElectrodeDetect): string {
  switch (object) {
    case ElectrodeDetect.NC:
      return "NC";
    case ElectrodeDetect.CODE_1:
      return "CODE_1";
    case ElectrodeDetect.CODE_2:
      return "CODE_2";
    case ElectrodeDetect.CODE_3:
      return "CODE_3";
    case ElectrodeDetect.CODE_4:
      return "CODE_4";
    case ElectrodeDetect.CODE_5:
      return "CODE_5";
    case ElectrodeDetect.CODE_6:
      return "CODE_6";
    case ElectrodeDetect.CODE_7:
      return "CODE_7";
    case ElectrodeDetect.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export function electrodeDetectToNumber(object: ElectrodeDetect): number {
  switch (object) {
    case ElectrodeDetect.NC:
      return 0;
    case ElectrodeDetect.CODE_1:
      return 1;
    case ElectrodeDetect.CODE_2:
      return 2;
    case ElectrodeDetect.CODE_3:
      return 3;
    case ElectrodeDetect.CODE_4:
      return 4;
    case ElectrodeDetect.CODE_5:
      return 5;
    case ElectrodeDetect.CODE_6:
      return 6;
    case ElectrodeDetect.CODE_7:
      return 7;
    case ElectrodeDetect.UNRECOGNIZED:
    default:
      return -1;
  }
}

/**
 * Log-lin scale from 'start' to 'end', descending when 'start > end'.
 * Out of range is rejected, never clamped.
 */
export interface Scaler {
  /** First frequency <0.1; 200000> [Hz] */
  start: number;
  /** Last frequency <0.1; 200000> [Hz] */
  end: number;
  /** Number of points >= 2, sweep within 'Limits.points_max' */
  count: number;
  /** <0; 1>, 0 = logarithmic, 1 = linear */
  blend: number;
}

/**
 * Potential held around a channel measurement, excitation off, phases in order below.
 * Cell stays connected from first phase to last. Zero disables a phase.
 * Pause after a point is 'interval_ms', not a phase.
 */
export interface Hold {
  /** WE at RE potential, before first point <0; 60000> [ms] */
  zeroBeforeMs: number;
  /** At first bias, before first point <0; 60000> [ms] */
  biasBeforeMs: number;
  /** At last bias, after last point <0; 60000> [ms] */
  biasAfterMs: number;
  /** Back to RE potential before cell release <0; 60000> [ms] */
  zeroAfterMs: number;
}

/**
 * Every field is required: omitted arrives as 0, each range says whether 0 is legal.
 * Ranges are inclusive unless written otherwise.
 */
export interface ImpedanceExec {
  /** What is measured */
  channels: CHAN[];
  /** Empty runs reference pass alone, result carries frequency axis and no channel */
  reference: Reference;
  /**
   * 'frequency_Hz' or 'frequency_auto', 'frequency_snap_pct', 'amplitude_mV', 'rtia_Ohm',
   * 'adc_gain', 'periods_min' and 'duration_min_ms' as the sweep that took it
   * Number 2 held 'repeated float frequency_Hz' in v1.4.4, reassigned not freed
   * Axes, slowest first: every interval runs every bias, every bias every amplitude, every
   * amplitude every frequency. Points are product of four lists and must fit
   * 'Limits.points_max'. Result arrays run in point order, frequency fastest
   */
  intervalMs: number[];
  /**
   * <0; 60000> [ms]. One entry paces every point, N entries run whole sweep N times,
   * each pass with its own pause. Empty runs points back to back
   */
  biasMV: number[];
  /** 0 puts WE at RE potential */
  amplitudeMV: number[];
  /** Linearity falls off above 25.7mV thermal voltage, sooner on some cells */
  frequencyHz: number[];
  /** Generates 'frequency_Hz' when that list is empty, else ignored */
  frequencyAuto?:
    | Scaler
    | undefined;
  /** How far device may move a frequency to read it whole */
  frequencySnapPct: number;
  /**
   * and clear of mains, share of itself >= 0 [%]. 0 holds it as asked.
   * 'ImpedanceResult.frequency_Hz' reports what ran
   * Readout path
   */
  rtiaOhm: TIA;
  /** ADC gain */
  adcGain: ADC;
  /**
   * One point in time order: settle, integrate, pause. Settling adds its two terms, integration
   * takes its longer term. Device may shorten time, never cycles: cycles out of reach
   * are rejected
   */
  settlePeriods: number;
  /** And this long on top <0; 60000> [ms] */
  settleMs: number;
  /** Integrate at least this many cycles <1; 4096> */
  periodsMin: number;
  /** Number 13 held 'bool frequency_snap' in v1.4.4, reassigned not freed */
  durationMinMs: number;
  /** Around a channel */
  hold: Hold | undefined;
}

/**
 * Firmware image on its way in, bytes in order from offset 0. 'UPDATE_BEGIN' names it,
 * every 'UPDATE_WRITE' brings next piece at offset 'State.update_offset' expects,
 * 'UPDATE_END' seals it. Transfer and measurement exclude each other, transfer without
 * a write for 30s is dropped
 */
export interface Update {
  /** Image bytes before trailer, as image header names them. 'UPDATE_BEGIN' */
  size: number;
  /** CRC-32 ISO over those bytes, verified in flash before install. 'UPDATE_BEGIN' */
  crc: number;
  /** Position of 'data' in image. 'UPDATE_WRITE' */
  offset: number;
  /** Next bytes of image, at most 1024. 'UPDATE_WRITE', never echoed */
  data: Uint8Array;
}

/** Request, one trigger with what it needs */
export interface AppMessage {
  /** Request id, nonzero, chosen by client, */
  id: bigint;
  /** echoed in every response */
  timestampMs: bigint;
  /** Nonzero sets device clock, on any trigger */
  trig: Triggers;
  /** Idle potential between measurements, all channels */
  standbyMV?:
    | number
    | undefined;
  /**
   * at once. <-1100; 1100> [mV], quantised as 'bias_mV'. Absent releases cells, 0 holds 0mV.
   * With a sweep running or started by this request it takes effect when sweep ends
   */
  update?:
    | Update
    | undefined;
  /**
   * and 'UPDATE_WRITE'
   * Number 5 held 'optional ImpedanceExec impedance_exec' in v1.4.4, reassigned not freed
   */
  impedanceExec?: ImpedanceExec | undefined;
}

/**
 * Everything measured on one channel. All arrays run in point order and share one length,
 * short when 'MEASURE_ABORT' interrupted this channel.
 */
export interface ImpedanceData {
  /** Channel of these points */
  channel: CHAN;
  /** Result */
  magnitudeOhm: number[];
  /** arg(Z) [rad] */
  phaseRad: number[];
  /** Extras */
  timeMs: number[];
  /** Excitation current amplitude, peak [µA] */
  currentAcUA: number[];
  /** DC current at bias, excitation off [µA], read at end */
  currentDcBeforeUA?:
    | number
    | undefined;
  /**
   * of 'Hold.bias_before_ms' when it is 70ms or longer. Absent without a read,
   * with several 'bias_mV' entries, and on reference
   */
  currentDcAfterUA?:
    | number
    | undefined;
  /** Analog frontend die before points [°C]. */
  temperatureBeforeC?:
    | number
    | undefined;
  /** Absent when sensor gave none */
  temperatureAfterC?:
    | number
    | undefined;
  /** Verdict */
  pointBitmask: number[];
}

/** Result of one sweep, every requested channel on one frequency axis */
export interface ImpedanceResult {
  /** Frequency that ran, per point [Hz]. */
  frequencyHz: number[];
  /** At one frequency all entries match */
  data: ImpedanceData[];
}

/** What device is doing and its conditions right now */
export interface State {
  /** Activity */
  processingId: bigint;
  /** Measurement progress [%] */
  progressPct: number;
  /** Firmware image bytes taken so far, where next 'UPDATE_WRITE' */
  updateOffset: number;
  /**
   * starts, 0 without a transfer
   * Surroundings
   */
  electrode: ElectrodeDetect;
  /** Ambient temperature [°C], last good reading */
  temperatureC: number;
  /** Ambient humidity [%], last good reading */
  humidityPct: number;
  /** Power */
  powerState: PowerState;
  /** Battery voltage [V] */
  batteryV: number;
  /** Battery level [%] */
  batteryPct: number;
  /** Verdict */
  issueBitmask: bigint;
}

/** Unit history. Monotonic, survives reset, counted since manufacture. */
export interface Statistics {
  /** Operating time, sleep excluded [min] */
  operatingTimeMin: number;
  /** Completed measurements */
  measurementCount: number;
  /** Watchdog resets */
  watchdogResets: number;
  /** Operating time at last watchdog reset [min], 0 = never */
  watchdogLastMin: number;
  /** Brownout resets, supply sagged while running */
  brownoutResets: number;
  /** Replies dropped, link never took them */
  linkDrops: number;
}

/** Packed '(major << 16) | (minor << 8) | patch' */
export interface Version {
  /** Hardware version */
  hardware: number;
  /** Firmware version */
  firmware: number;
  /** BLE HCI/stack version */
  bluetooth: number;
  /** Protobuf schema version */
  protocol: number;
}

/** What device can take, fixed for a build */
export interface Limits {
  /** Points one reply carries, shared by requested channels: */
  pointsMax: number;
  /** channels × (bias × amplitude × frequency × interval) must not exceed it */
  imageMax: number;
}

/** Response to a request, or a broadcast */
export interface DevMessage {
  /** Unit and build, fixed */
  uid: Uint8Array;
  /** Serial number, '(batch << 16) | piece' */
  serialNumber: number;
  /** All versions */
  version:
    | Version
    | undefined;
  /** What device can take */
  limits:
    | Limits
    | undefined;
  /** Live */
  state:
    | State
    | undefined;
  /** Lifetime counters */
  statistics?:
    | Statistics
    | undefined;
  /** Answer */
  errorCode: number;
  /**
   * Nonzero is not no data: aborted sweep reports an error and still carries points it took,
   * any other sweep error carries no result to trust. Sweep finished with reservations
   * reports 0 and flags them in 'State.issue_bitmask'
   */
  appMessage?:
    | AppMessage
    | undefined;
  /**
   * Absent in a broadcast, which answers nothing, and when request failed to decode.
   * Always carries 'id', so a response matches its request. With a result, 'impedance_exec'
   * holds settings as executed, not as requested. 'Update.data' is never echoed
   */
  durationMs: number;
  /** EIS result, one entry per requested channel. */
  impedanceResult?: ImpedanceResult | undefined;
}

function createBaseScaler(): Scaler {
  return { start: 0, end: 0, count: 0, blend: 0 };
}

export const Scaler: MessageFns<Scaler> = {
  encode(message: Scaler, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.start !== 0) {
      writer.uint32(13).float(message.start);
    }
    if (message.end !== 0) {
      writer.uint32(21).float(message.end);
    }
    if (message.count !== 0) {
      writer.uint32(24).uint32(message.count);
    }
    if (message.blend !== 0) {
      writer.uint32(37).float(message.blend);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Scaler {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScaler();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 13) {
            break;
          }

          message.start = reader.float();
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.end = reader.float();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.count = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.blend = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Scaler {
    return {
      start: isSet(object.start) ? globalThis.Number(object.start) : 0,
      end: isSet(object.end) ? globalThis.Number(object.end) : 0,
      count: isSet(object.count) ? globalThis.Number(object.count) : 0,
      blend: isSet(object.blend) ? globalThis.Number(object.blend) : 0,
    };
  },

  toJSON(message: Scaler): unknown {
    const obj: any = {};
    if (message.start !== 0) {
      obj.start = message.start;
    }
    if (message.end !== 0) {
      obj.end = message.end;
    }
    if (message.count !== 0) {
      obj.count = Math.round(message.count);
    }
    if (message.blend !== 0) {
      obj.blend = message.blend;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Scaler>, I>>(base?: I): Scaler {
    return Scaler.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Scaler>, I>>(object: I): Scaler {
    const message = createBaseScaler();
    message.start = object.start ?? 0;
    message.end = object.end ?? 0;
    message.count = object.count ?? 0;
    message.blend = object.blend ?? 0;
    return message;
  },
};

function createBaseHold(): Hold {
  return { zeroBeforeMs: 0, biasBeforeMs: 0, biasAfterMs: 0, zeroAfterMs: 0 };
}

export const Hold: MessageFns<Hold> = {
  encode(message: Hold, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.zeroBeforeMs !== 0) {
      writer.uint32(8).uint32(message.zeroBeforeMs);
    }
    if (message.biasBeforeMs !== 0) {
      writer.uint32(16).uint32(message.biasBeforeMs);
    }
    if (message.biasAfterMs !== 0) {
      writer.uint32(24).uint32(message.biasAfterMs);
    }
    if (message.zeroAfterMs !== 0) {
      writer.uint32(32).uint32(message.zeroAfterMs);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Hold {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHold();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.zeroBeforeMs = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.biasBeforeMs = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.biasAfterMs = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.zeroAfterMs = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Hold {
    return {
      zeroBeforeMs: isSet(object.zeroBeforeMs) ? globalThis.Number(object.zeroBeforeMs) : 0,
      biasBeforeMs: isSet(object.biasBeforeMs) ? globalThis.Number(object.biasBeforeMs) : 0,
      biasAfterMs: isSet(object.biasAfterMs) ? globalThis.Number(object.biasAfterMs) : 0,
      zeroAfterMs: isSet(object.zeroAfterMs) ? globalThis.Number(object.zeroAfterMs) : 0,
    };
  },

  toJSON(message: Hold): unknown {
    const obj: any = {};
    if (message.zeroBeforeMs !== 0) {
      obj.zeroBeforeMs = Math.round(message.zeroBeforeMs);
    }
    if (message.biasBeforeMs !== 0) {
      obj.biasBeforeMs = Math.round(message.biasBeforeMs);
    }
    if (message.biasAfterMs !== 0) {
      obj.biasAfterMs = Math.round(message.biasAfterMs);
    }
    if (message.zeroAfterMs !== 0) {
      obj.zeroAfterMs = Math.round(message.zeroAfterMs);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Hold>, I>>(base?: I): Hold {
    return Hold.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Hold>, I>>(object: I): Hold {
    const message = createBaseHold();
    message.zeroBeforeMs = object.zeroBeforeMs ?? 0;
    message.biasBeforeMs = object.biasBeforeMs ?? 0;
    message.biasAfterMs = object.biasAfterMs ?? 0;
    message.zeroAfterMs = object.zeroAfterMs ?? 0;
    return message;
  },
};

function createBaseImpedanceExec(): ImpedanceExec {
  return {
    channels: [],
    reference: Reference.BEFORE,
    intervalMs: [],
    biasMV: [],
    amplitudeMV: [],
    frequencyHz: [],
    frequencyAuto: undefined,
    frequencySnapPct: 0,
    rtiaOhm: TIA.Resistor_200Ohm,
    adcGain: ADC.Gain_1,
    settlePeriods: 0,
    settleMs: 0,
    periodsMin: 0,
    durationMinMs: 0,
    hold: undefined,
  };
}

export const ImpedanceExec: MessageFns<ImpedanceExec> = {
  encode(message: ImpedanceExec, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork();
    for (const v of message.channels) {
      writer.int32(cHANToNumber(v));
    }
    writer.join();
    if (message.reference !== Reference.BEFORE) {
      writer.uint32(16).int32(referenceToNumber(message.reference));
    }
    writer.uint32(26).fork();
    for (const v of message.intervalMs) {
      writer.uint32(v);
    }
    writer.join();
    writer.uint32(34).fork();
    for (const v of message.biasMV) {
      writer.float(v);
    }
    writer.join();
    writer.uint32(42).fork();
    for (const v of message.amplitudeMV) {
      writer.float(v);
    }
    writer.join();
    writer.uint32(50).fork();
    for (const v of message.frequencyHz) {
      writer.float(v);
    }
    writer.join();
    if (message.frequencyAuto !== undefined) {
      Scaler.encode(message.frequencyAuto, writer.uint32(58).fork()).join();
    }
    if (message.frequencySnapPct !== 0) {
      writer.uint32(69).float(message.frequencySnapPct);
    }
    if (message.rtiaOhm !== TIA.Resistor_200Ohm) {
      writer.uint32(72).int32(tIAToNumber(message.rtiaOhm));
    }
    if (message.adcGain !== ADC.Gain_1) {
      writer.uint32(80).int32(aDCToNumber(message.adcGain));
    }
    if (message.settlePeriods !== 0) {
      writer.uint32(88).uint32(message.settlePeriods);
    }
    if (message.settleMs !== 0) {
      writer.uint32(96).uint32(message.settleMs);
    }
    if (message.periodsMin !== 0) {
      writer.uint32(104).uint32(message.periodsMin);
    }
    if (message.durationMinMs !== 0) {
      writer.uint32(112).uint32(message.durationMinMs);
    }
    if (message.hold !== undefined) {
      Hold.encode(message.hold, writer.uint32(122).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ImpedanceExec {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseImpedanceExec();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag === 8) {
            message.channels.push(cHANFromJSON(reader.int32()));

            continue;
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.channels.push(cHANFromJSON(reader.int32()));
            }

            continue;
          }

          break;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.reference = referenceFromJSON(reader.int32());
          continue;
        }
        case 3: {
          if (tag === 24) {
            message.intervalMs.push(reader.uint32());

            continue;
          }

          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.intervalMs.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 4: {
          if (tag === 37) {
            message.biasMV.push(reader.float());

            continue;
          }

          if (tag === 34) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.biasMV.push(reader.float());
            }

            continue;
          }

          break;
        }
        case 5: {
          if (tag === 45) {
            message.amplitudeMV.push(reader.float());

            continue;
          }

          if (tag === 42) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.amplitudeMV.push(reader.float());
            }

            continue;
          }

          break;
        }
        case 6: {
          if (tag === 53) {
            message.frequencyHz.push(reader.float());

            continue;
          }

          if (tag === 50) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.frequencyHz.push(reader.float());
            }

            continue;
          }

          break;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.frequencyAuto = Scaler.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 69) {
            break;
          }

          message.frequencySnapPct = reader.float();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.rtiaOhm = tIAFromJSON(reader.int32());
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.adcGain = aDCFromJSON(reader.int32());
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.settlePeriods = reader.uint32();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.settleMs = reader.uint32();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.periodsMin = reader.uint32();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.durationMinMs = reader.uint32();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.hold = Hold.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ImpedanceExec {
    return {
      channels: globalThis.Array.isArray(object?.channels) ? object.channels.map((e: any) => cHANFromJSON(e)) : [],
      reference: isSet(object.reference) ? referenceFromJSON(object.reference) : Reference.BEFORE,
      intervalMs: globalThis.Array.isArray(object?.intervalMs)
        ? object.intervalMs.map((e: any) => globalThis.Number(e))
        : [],
      biasMV: globalThis.Array.isArray(object?.biasMV) ? object.biasMV.map((e: any) => globalThis.Number(e)) : [],
      amplitudeMV: globalThis.Array.isArray(object?.amplitudeMV)
        ? object.amplitudeMV.map((e: any) => globalThis.Number(e))
        : [],
      frequencyHz: globalThis.Array.isArray(object?.frequencyHz)
        ? object.frequencyHz.map((e: any) => globalThis.Number(e))
        : [],
      frequencyAuto: isSet(object.frequencyAuto) ? Scaler.fromJSON(object.frequencyAuto) : undefined,
      frequencySnapPct: isSet(object.frequencySnapPct) ? globalThis.Number(object.frequencySnapPct) : 0,
      rtiaOhm: isSet(object.rtiaOhm) ? tIAFromJSON(object.rtiaOhm) : TIA.Resistor_200Ohm,
      adcGain: isSet(object.adcGain) ? aDCFromJSON(object.adcGain) : ADC.Gain_1,
      settlePeriods: isSet(object.settlePeriods) ? globalThis.Number(object.settlePeriods) : 0,
      settleMs: isSet(object.settleMs) ? globalThis.Number(object.settleMs) : 0,
      periodsMin: isSet(object.periodsMin) ? globalThis.Number(object.periodsMin) : 0,
      durationMinMs: isSet(object.durationMinMs) ? globalThis.Number(object.durationMinMs) : 0,
      hold: isSet(object.hold) ? Hold.fromJSON(object.hold) : undefined,
    };
  },

  toJSON(message: ImpedanceExec): unknown {
    const obj: any = {};
    if (message.channels?.length) {
      obj.channels = message.channels.map((e) => cHANToJSON(e));
    }
    if (message.reference !== Reference.BEFORE) {
      obj.reference = referenceToJSON(message.reference);
    }
    if (message.intervalMs?.length) {
      obj.intervalMs = message.intervalMs.map((e) => Math.round(e));
    }
    if (message.biasMV?.length) {
      obj.biasMV = message.biasMV;
    }
    if (message.amplitudeMV?.length) {
      obj.amplitudeMV = message.amplitudeMV;
    }
    if (message.frequencyHz?.length) {
      obj.frequencyHz = message.frequencyHz;
    }
    if (message.frequencyAuto !== undefined) {
      obj.frequencyAuto = Scaler.toJSON(message.frequencyAuto);
    }
    if (message.frequencySnapPct !== 0) {
      obj.frequencySnapPct = message.frequencySnapPct;
    }
    if (message.rtiaOhm !== TIA.Resistor_200Ohm) {
      obj.rtiaOhm = tIAToJSON(message.rtiaOhm);
    }
    if (message.adcGain !== ADC.Gain_1) {
      obj.adcGain = aDCToJSON(message.adcGain);
    }
    if (message.settlePeriods !== 0) {
      obj.settlePeriods = Math.round(message.settlePeriods);
    }
    if (message.settleMs !== 0) {
      obj.settleMs = Math.round(message.settleMs);
    }
    if (message.periodsMin !== 0) {
      obj.periodsMin = Math.round(message.periodsMin);
    }
    if (message.durationMinMs !== 0) {
      obj.durationMinMs = Math.round(message.durationMinMs);
    }
    if (message.hold !== undefined) {
      obj.hold = Hold.toJSON(message.hold);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ImpedanceExec>, I>>(base?: I): ImpedanceExec {
    return ImpedanceExec.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ImpedanceExec>, I>>(object: I): ImpedanceExec {
    const message = createBaseImpedanceExec();
    message.channels = object.channels?.map((e) => e) || [];
    message.reference = object.reference ?? Reference.BEFORE;
    message.intervalMs = object.intervalMs?.map((e) => e) || [];
    message.biasMV = object.biasMV?.map((e) => e) || [];
    message.amplitudeMV = object.amplitudeMV?.map((e) => e) || [];
    message.frequencyHz = object.frequencyHz?.map((e) => e) || [];
    message.frequencyAuto = (object.frequencyAuto !== undefined && object.frequencyAuto !== null)
      ? Scaler.fromPartial(object.frequencyAuto)
      : undefined;
    message.frequencySnapPct = object.frequencySnapPct ?? 0;
    message.rtiaOhm = object.rtiaOhm ?? TIA.Resistor_200Ohm;
    message.adcGain = object.adcGain ?? ADC.Gain_1;
    message.settlePeriods = object.settlePeriods ?? 0;
    message.settleMs = object.settleMs ?? 0;
    message.periodsMin = object.periodsMin ?? 0;
    message.durationMinMs = object.durationMinMs ?? 0;
    message.hold = (object.hold !== undefined && object.hold !== null) ? Hold.fromPartial(object.hold) : undefined;
    return message;
  },
};

function createBaseUpdate(): Update {
  return { size: 0, crc: 0, offset: 0, data: new Uint8Array(0) };
}

export const Update: MessageFns<Update> = {
  encode(message: Update, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.size !== 0) {
      writer.uint32(8).uint32(message.size);
    }
    if (message.crc !== 0) {
      writer.uint32(16).uint32(message.crc);
    }
    if (message.offset !== 0) {
      writer.uint32(24).uint32(message.offset);
    }
    if (message.data.length !== 0) {
      writer.uint32(34).bytes(message.data);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Update {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.size = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.crc = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.offset = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.data = reader.bytes();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Update {
    return {
      size: isSet(object.size) ? globalThis.Number(object.size) : 0,
      crc: isSet(object.crc) ? globalThis.Number(object.crc) : 0,
      offset: isSet(object.offset) ? globalThis.Number(object.offset) : 0,
      data: isSet(object.data) ? bytesFromBase64(object.data) : new Uint8Array(0),
    };
  },

  toJSON(message: Update): unknown {
    const obj: any = {};
    if (message.size !== 0) {
      obj.size = Math.round(message.size);
    }
    if (message.crc !== 0) {
      obj.crc = Math.round(message.crc);
    }
    if (message.offset !== 0) {
      obj.offset = Math.round(message.offset);
    }
    if (message.data.length !== 0) {
      obj.data = base64FromBytes(message.data);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Update>, I>>(base?: I): Update {
    return Update.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Update>, I>>(object: I): Update {
    const message = createBaseUpdate();
    message.size = object.size ?? 0;
    message.crc = object.crc ?? 0;
    message.offset = object.offset ?? 0;
    message.data = object.data ?? new Uint8Array(0);
    return message;
  },
};

function createBaseAppMessage(): AppMessage {
  return {
    id: 0n,
    timestampMs: 0n,
    trig: Triggers.NONE,
    standbyMV: undefined,
    update: undefined,
    impedanceExec: undefined,
  };
}

export const AppMessage: MessageFns<AppMessage> = {
  encode(message: AppMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0n) {
      if (BigInt.asUintN(64, message.id) !== message.id) {
        throw new globalThis.Error("value provided for field message.id of type uint64 too large");
      }
      writer.uint32(8).uint64(message.id);
    }
    if (message.timestampMs !== 0n) {
      if (BigInt.asUintN(64, message.timestampMs) !== message.timestampMs) {
        throw new globalThis.Error("value provided for field message.timestampMs of type uint64 too large");
      }
      writer.uint32(16).uint64(message.timestampMs);
    }
    if (message.trig !== Triggers.NONE) {
      writer.uint32(24).int32(triggersToNumber(message.trig));
    }
    if (message.standbyMV !== undefined) {
      writer.uint32(37).float(message.standbyMV);
    }
    if (message.update !== undefined) {
      Update.encode(message.update, writer.uint32(42).fork()).join();
    }
    if (message.impedanceExec !== undefined) {
      ImpedanceExec.encode(message.impedanceExec, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AppMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAppMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.uint64() as bigint;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.timestampMs = reader.uint64() as bigint;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.trig = triggersFromJSON(reader.int32());
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.standbyMV = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.update = Update.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.impedanceExec = ImpedanceExec.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AppMessage {
    return {
      id: isSet(object.id) ? BigInt(object.id) : 0n,
      timestampMs: isSet(object.timestampMs) ? BigInt(object.timestampMs) : 0n,
      trig: isSet(object.trig) ? triggersFromJSON(object.trig) : Triggers.NONE,
      standbyMV: isSet(object.standbyMV) ? globalThis.Number(object.standbyMV) : undefined,
      update: isSet(object.update) ? Update.fromJSON(object.update) : undefined,
      impedanceExec: isSet(object.impedanceExec) ? ImpedanceExec.fromJSON(object.impedanceExec) : undefined,
    };
  },

  toJSON(message: AppMessage): unknown {
    const obj: any = {};
    if (message.id !== 0n) {
      obj.id = message.id.toString();
    }
    if (message.timestampMs !== 0n) {
      obj.timestampMs = message.timestampMs.toString();
    }
    if (message.trig !== Triggers.NONE) {
      obj.trig = triggersToJSON(message.trig);
    }
    if (message.standbyMV !== undefined) {
      obj.standbyMV = message.standbyMV;
    }
    if (message.update !== undefined) {
      obj.update = Update.toJSON(message.update);
    }
    if (message.impedanceExec !== undefined) {
      obj.impedanceExec = ImpedanceExec.toJSON(message.impedanceExec);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AppMessage>, I>>(base?: I): AppMessage {
    return AppMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AppMessage>, I>>(object: I): AppMessage {
    const message = createBaseAppMessage();
    message.id = object.id ?? 0n;
    message.timestampMs = object.timestampMs ?? 0n;
    message.trig = object.trig ?? Triggers.NONE;
    message.standbyMV = object.standbyMV ?? undefined;
    message.update = (object.update !== undefined && object.update !== null)
      ? Update.fromPartial(object.update)
      : undefined;
    message.impedanceExec = (object.impedanceExec !== undefined && object.impedanceExec !== null)
      ? ImpedanceExec.fromPartial(object.impedanceExec)
      : undefined;
    return message;
  },
};

function createBaseImpedanceData(): ImpedanceData {
  return {
    channel: CHAN.OPEN,
    magnitudeOhm: [],
    phaseRad: [],
    timeMs: [],
    currentAcUA: [],
    currentDcBeforeUA: undefined,
    currentDcAfterUA: undefined,
    temperatureBeforeC: undefined,
    temperatureAfterC: undefined,
    pointBitmask: [],
  };
}

export const ImpedanceData: MessageFns<ImpedanceData> = {
  encode(message: ImpedanceData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.channel !== CHAN.OPEN) {
      writer.uint32(8).int32(cHANToNumber(message.channel));
    }
    writer.uint32(18).fork();
    for (const v of message.magnitudeOhm) {
      writer.float(v);
    }
    writer.join();
    writer.uint32(26).fork();
    for (const v of message.phaseRad) {
      writer.float(v);
    }
    writer.join();
    writer.uint32(34).fork();
    for (const v of message.timeMs) {
      writer.uint32(v);
    }
    writer.join();
    writer.uint32(42).fork();
    for (const v of message.currentAcUA) {
      writer.float(v);
    }
    writer.join();
    if (message.currentDcBeforeUA !== undefined) {
      writer.uint32(53).float(message.currentDcBeforeUA);
    }
    if (message.currentDcAfterUA !== undefined) {
      writer.uint32(61).float(message.currentDcAfterUA);
    }
    if (message.temperatureBeforeC !== undefined) {
      writer.uint32(69).float(message.temperatureBeforeC);
    }
    if (message.temperatureAfterC !== undefined) {
      writer.uint32(77).float(message.temperatureAfterC);
    }
    writer.uint32(82).fork();
    for (const v of message.pointBitmask) {
      writer.uint32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ImpedanceData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseImpedanceData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.channel = cHANFromJSON(reader.int32());
          continue;
        }
        case 2: {
          if (tag === 21) {
            message.magnitudeOhm.push(reader.float());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.magnitudeOhm.push(reader.float());
            }

            continue;
          }

          break;
        }
        case 3: {
          if (tag === 29) {
            message.phaseRad.push(reader.float());

            continue;
          }

          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.phaseRad.push(reader.float());
            }

            continue;
          }

          break;
        }
        case 4: {
          if (tag === 32) {
            message.timeMs.push(reader.uint32());

            continue;
          }

          if (tag === 34) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.timeMs.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 5: {
          if (tag === 45) {
            message.currentAcUA.push(reader.float());

            continue;
          }

          if (tag === 42) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.currentAcUA.push(reader.float());
            }

            continue;
          }

          break;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.currentDcBeforeUA = reader.float();
          continue;
        }
        case 7: {
          if (tag !== 61) {
            break;
          }

          message.currentDcAfterUA = reader.float();
          continue;
        }
        case 8: {
          if (tag !== 69) {
            break;
          }

          message.temperatureBeforeC = reader.float();
          continue;
        }
        case 9: {
          if (tag !== 77) {
            break;
          }

          message.temperatureAfterC = reader.float();
          continue;
        }
        case 10: {
          if (tag === 80) {
            message.pointBitmask.push(reader.uint32());

            continue;
          }

          if (tag === 82) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.pointBitmask.push(reader.uint32());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ImpedanceData {
    return {
      channel: isSet(object.channel) ? cHANFromJSON(object.channel) : CHAN.OPEN,
      magnitudeOhm: globalThis.Array.isArray(object?.magnitudeOhm)
        ? object.magnitudeOhm.map((e: any) => globalThis.Number(e))
        : [],
      phaseRad: globalThis.Array.isArray(object?.phaseRad) ? object.phaseRad.map((e: any) => globalThis.Number(e)) : [],
      timeMs: globalThis.Array.isArray(object?.timeMs) ? object.timeMs.map((e: any) => globalThis.Number(e)) : [],
      currentAcUA: globalThis.Array.isArray(object?.currentAcUA)
        ? object.currentAcUA.map((e: any) => globalThis.Number(e))
        : [],
      currentDcBeforeUA: isSet(object.currentDcBeforeUA) ? globalThis.Number(object.currentDcBeforeUA) : undefined,
      currentDcAfterUA: isSet(object.currentDcAfterUA) ? globalThis.Number(object.currentDcAfterUA) : undefined,
      temperatureBeforeC: isSet(object.temperatureBeforeC) ? globalThis.Number(object.temperatureBeforeC) : undefined,
      temperatureAfterC: isSet(object.temperatureAfterC) ? globalThis.Number(object.temperatureAfterC) : undefined,
      pointBitmask: globalThis.Array.isArray(object?.pointBitmask)
        ? object.pointBitmask.map((e: any) => globalThis.Number(e))
        : [],
    };
  },

  toJSON(message: ImpedanceData): unknown {
    const obj: any = {};
    if (message.channel !== CHAN.OPEN) {
      obj.channel = cHANToJSON(message.channel);
    }
    if (message.magnitudeOhm?.length) {
      obj.magnitudeOhm = message.magnitudeOhm;
    }
    if (message.phaseRad?.length) {
      obj.phaseRad = message.phaseRad;
    }
    if (message.timeMs?.length) {
      obj.timeMs = message.timeMs.map((e) => Math.round(e));
    }
    if (message.currentAcUA?.length) {
      obj.currentAcUA = message.currentAcUA;
    }
    if (message.currentDcBeforeUA !== undefined) {
      obj.currentDcBeforeUA = message.currentDcBeforeUA;
    }
    if (message.currentDcAfterUA !== undefined) {
      obj.currentDcAfterUA = message.currentDcAfterUA;
    }
    if (message.temperatureBeforeC !== undefined) {
      obj.temperatureBeforeC = message.temperatureBeforeC;
    }
    if (message.temperatureAfterC !== undefined) {
      obj.temperatureAfterC = message.temperatureAfterC;
    }
    if (message.pointBitmask?.length) {
      obj.pointBitmask = message.pointBitmask.map((e) => Math.round(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ImpedanceData>, I>>(base?: I): ImpedanceData {
    return ImpedanceData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ImpedanceData>, I>>(object: I): ImpedanceData {
    const message = createBaseImpedanceData();
    message.channel = object.channel ?? CHAN.OPEN;
    message.magnitudeOhm = object.magnitudeOhm?.map((e) => e) || [];
    message.phaseRad = object.phaseRad?.map((e) => e) || [];
    message.timeMs = object.timeMs?.map((e) => e) || [];
    message.currentAcUA = object.currentAcUA?.map((e) => e) || [];
    message.currentDcBeforeUA = object.currentDcBeforeUA ?? undefined;
    message.currentDcAfterUA = object.currentDcAfterUA ?? undefined;
    message.temperatureBeforeC = object.temperatureBeforeC ?? undefined;
    message.temperatureAfterC = object.temperatureAfterC ?? undefined;
    message.pointBitmask = object.pointBitmask?.map((e) => e) || [];
    return message;
  },
};

function createBaseImpedanceResult(): ImpedanceResult {
  return { frequencyHz: [], data: [] };
}

export const ImpedanceResult: MessageFns<ImpedanceResult> = {
  encode(message: ImpedanceResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork();
    for (const v of message.frequencyHz) {
      writer.float(v);
    }
    writer.join();
    for (const v of message.data) {
      ImpedanceData.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ImpedanceResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseImpedanceResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag === 13) {
            message.frequencyHz.push(reader.float());

            continue;
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.frequencyHz.push(reader.float());
            }

            continue;
          }

          break;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.data.push(ImpedanceData.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ImpedanceResult {
    return {
      frequencyHz: globalThis.Array.isArray(object?.frequencyHz)
        ? object.frequencyHz.map((e: any) => globalThis.Number(e))
        : [],
      data: globalThis.Array.isArray(object?.data) ? object.data.map((e: any) => ImpedanceData.fromJSON(e)) : [],
    };
  },

  toJSON(message: ImpedanceResult): unknown {
    const obj: any = {};
    if (message.frequencyHz?.length) {
      obj.frequencyHz = message.frequencyHz;
    }
    if (message.data?.length) {
      obj.data = message.data.map((e) => ImpedanceData.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ImpedanceResult>, I>>(base?: I): ImpedanceResult {
    return ImpedanceResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ImpedanceResult>, I>>(object: I): ImpedanceResult {
    const message = createBaseImpedanceResult();
    message.frequencyHz = object.frequencyHz?.map((e) => e) || [];
    message.data = object.data?.map((e) => ImpedanceData.fromPartial(e)) || [];
    return message;
  },
};

function createBaseState(): State {
  return {
    processingId: 0n,
    progressPct: 0,
    updateOffset: 0,
    electrode: ElectrodeDetect.NC,
    temperatureC: 0,
    humidityPct: 0,
    powerState: PowerState.UNKNOWN,
    batteryV: 0,
    batteryPct: 0,
    issueBitmask: 0n,
  };
}

export const State: MessageFns<State> = {
  encode(message: State, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.processingId !== 0n) {
      if (BigInt.asUintN(64, message.processingId) !== message.processingId) {
        throw new globalThis.Error("value provided for field message.processingId of type uint64 too large");
      }
      writer.uint32(8).uint64(message.processingId);
    }
    if (message.progressPct !== 0) {
      writer.uint32(21).float(message.progressPct);
    }
    if (message.updateOffset !== 0) {
      writer.uint32(24).uint32(message.updateOffset);
    }
    if (message.electrode !== ElectrodeDetect.NC) {
      writer.uint32(32).int32(electrodeDetectToNumber(message.electrode));
    }
    if (message.temperatureC !== 0) {
      writer.uint32(45).float(message.temperatureC);
    }
    if (message.humidityPct !== 0) {
      writer.uint32(53).float(message.humidityPct);
    }
    if (message.powerState !== PowerState.UNKNOWN) {
      writer.uint32(56).int32(powerStateToNumber(message.powerState));
    }
    if (message.batteryV !== 0) {
      writer.uint32(69).float(message.batteryV);
    }
    if (message.batteryPct !== 0) {
      writer.uint32(77).float(message.batteryPct);
    }
    if (message.issueBitmask !== 0n) {
      if (BigInt.asUintN(64, message.issueBitmask) !== message.issueBitmask) {
        throw new globalThis.Error("value provided for field message.issueBitmask of type uint64 too large");
      }
      writer.uint32(80).uint64(message.issueBitmask);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): State {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.processingId = reader.uint64() as bigint;
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.progressPct = reader.float();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.updateOffset = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.electrode = electrodeDetectFromJSON(reader.int32());
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.temperatureC = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.humidityPct = reader.float();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.powerState = powerStateFromJSON(reader.int32());
          continue;
        }
        case 8: {
          if (tag !== 69) {
            break;
          }

          message.batteryV = reader.float();
          continue;
        }
        case 9: {
          if (tag !== 77) {
            break;
          }

          message.batteryPct = reader.float();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.issueBitmask = reader.uint64() as bigint;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): State {
    return {
      processingId: isSet(object.processingId) ? BigInt(object.processingId) : 0n,
      progressPct: isSet(object.progressPct) ? globalThis.Number(object.progressPct) : 0,
      updateOffset: isSet(object.updateOffset) ? globalThis.Number(object.updateOffset) : 0,
      electrode: isSet(object.electrode) ? electrodeDetectFromJSON(object.electrode) : ElectrodeDetect.NC,
      temperatureC: isSet(object.temperatureC) ? globalThis.Number(object.temperatureC) : 0,
      humidityPct: isSet(object.humidityPct) ? globalThis.Number(object.humidityPct) : 0,
      powerState: isSet(object.powerState) ? powerStateFromJSON(object.powerState) : PowerState.UNKNOWN,
      batteryV: isSet(object.batteryV) ? globalThis.Number(object.batteryV) : 0,
      batteryPct: isSet(object.batteryPct) ? globalThis.Number(object.batteryPct) : 0,
      issueBitmask: isSet(object.issueBitmask) ? BigInt(object.issueBitmask) : 0n,
    };
  },

  toJSON(message: State): unknown {
    const obj: any = {};
    if (message.processingId !== 0n) {
      obj.processingId = message.processingId.toString();
    }
    if (message.progressPct !== 0) {
      obj.progressPct = message.progressPct;
    }
    if (message.updateOffset !== 0) {
      obj.updateOffset = Math.round(message.updateOffset);
    }
    if (message.electrode !== ElectrodeDetect.NC) {
      obj.electrode = electrodeDetectToJSON(message.electrode);
    }
    if (message.temperatureC !== 0) {
      obj.temperatureC = message.temperatureC;
    }
    if (message.humidityPct !== 0) {
      obj.humidityPct = message.humidityPct;
    }
    if (message.powerState !== PowerState.UNKNOWN) {
      obj.powerState = powerStateToJSON(message.powerState);
    }
    if (message.batteryV !== 0) {
      obj.batteryV = message.batteryV;
    }
    if (message.batteryPct !== 0) {
      obj.batteryPct = message.batteryPct;
    }
    if (message.issueBitmask !== 0n) {
      obj.issueBitmask = message.issueBitmask.toString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<State>, I>>(base?: I): State {
    return State.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<State>, I>>(object: I): State {
    const message = createBaseState();
    message.processingId = object.processingId ?? 0n;
    message.progressPct = object.progressPct ?? 0;
    message.updateOffset = object.updateOffset ?? 0;
    message.electrode = object.electrode ?? ElectrodeDetect.NC;
    message.temperatureC = object.temperatureC ?? 0;
    message.humidityPct = object.humidityPct ?? 0;
    message.powerState = object.powerState ?? PowerState.UNKNOWN;
    message.batteryV = object.batteryV ?? 0;
    message.batteryPct = object.batteryPct ?? 0;
    message.issueBitmask = object.issueBitmask ?? 0n;
    return message;
  },
};

function createBaseStatistics(): Statistics {
  return {
    operatingTimeMin: 0,
    measurementCount: 0,
    watchdogResets: 0,
    watchdogLastMin: 0,
    brownoutResets: 0,
    linkDrops: 0,
  };
}

export const Statistics: MessageFns<Statistics> = {
  encode(message: Statistics, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.operatingTimeMin !== 0) {
      writer.uint32(8).uint32(message.operatingTimeMin);
    }
    if (message.measurementCount !== 0) {
      writer.uint32(16).uint32(message.measurementCount);
    }
    if (message.watchdogResets !== 0) {
      writer.uint32(24).uint32(message.watchdogResets);
    }
    if (message.watchdogLastMin !== 0) {
      writer.uint32(32).uint32(message.watchdogLastMin);
    }
    if (message.brownoutResets !== 0) {
      writer.uint32(40).uint32(message.brownoutResets);
    }
    if (message.linkDrops !== 0) {
      writer.uint32(48).uint32(message.linkDrops);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Statistics {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStatistics();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.operatingTimeMin = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.measurementCount = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.watchdogResets = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.watchdogLastMin = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.brownoutResets = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.linkDrops = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Statistics {
    return {
      operatingTimeMin: isSet(object.operatingTimeMin) ? globalThis.Number(object.operatingTimeMin) : 0,
      measurementCount: isSet(object.measurementCount) ? globalThis.Number(object.measurementCount) : 0,
      watchdogResets: isSet(object.watchdogResets) ? globalThis.Number(object.watchdogResets) : 0,
      watchdogLastMin: isSet(object.watchdogLastMin) ? globalThis.Number(object.watchdogLastMin) : 0,
      brownoutResets: isSet(object.brownoutResets) ? globalThis.Number(object.brownoutResets) : 0,
      linkDrops: isSet(object.linkDrops) ? globalThis.Number(object.linkDrops) : 0,
    };
  },

  toJSON(message: Statistics): unknown {
    const obj: any = {};
    if (message.operatingTimeMin !== 0) {
      obj.operatingTimeMin = Math.round(message.operatingTimeMin);
    }
    if (message.measurementCount !== 0) {
      obj.measurementCount = Math.round(message.measurementCount);
    }
    if (message.watchdogResets !== 0) {
      obj.watchdogResets = Math.round(message.watchdogResets);
    }
    if (message.watchdogLastMin !== 0) {
      obj.watchdogLastMin = Math.round(message.watchdogLastMin);
    }
    if (message.brownoutResets !== 0) {
      obj.brownoutResets = Math.round(message.brownoutResets);
    }
    if (message.linkDrops !== 0) {
      obj.linkDrops = Math.round(message.linkDrops);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Statistics>, I>>(base?: I): Statistics {
    return Statistics.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Statistics>, I>>(object: I): Statistics {
    const message = createBaseStatistics();
    message.operatingTimeMin = object.operatingTimeMin ?? 0;
    message.measurementCount = object.measurementCount ?? 0;
    message.watchdogResets = object.watchdogResets ?? 0;
    message.watchdogLastMin = object.watchdogLastMin ?? 0;
    message.brownoutResets = object.brownoutResets ?? 0;
    message.linkDrops = object.linkDrops ?? 0;
    return message;
  },
};

function createBaseVersion(): Version {
  return { hardware: 0, firmware: 0, bluetooth: 0, protocol: 0 };
}

export const Version: MessageFns<Version> = {
  encode(message: Version, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.hardware !== 0) {
      writer.uint32(8).uint32(message.hardware);
    }
    if (message.firmware !== 0) {
      writer.uint32(16).uint32(message.firmware);
    }
    if (message.bluetooth !== 0) {
      writer.uint32(24).uint32(message.bluetooth);
    }
    if (message.protocol !== 0) {
      writer.uint32(32).uint32(message.protocol);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Version {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVersion();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.hardware = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.firmware = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.bluetooth = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.protocol = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Version {
    return {
      hardware: isSet(object.hardware) ? globalThis.Number(object.hardware) : 0,
      firmware: isSet(object.firmware) ? globalThis.Number(object.firmware) : 0,
      bluetooth: isSet(object.bluetooth) ? globalThis.Number(object.bluetooth) : 0,
      protocol: isSet(object.protocol) ? globalThis.Number(object.protocol) : 0,
    };
  },

  toJSON(message: Version): unknown {
    const obj: any = {};
    if (message.hardware !== 0) {
      obj.hardware = Math.round(message.hardware);
    }
    if (message.firmware !== 0) {
      obj.firmware = Math.round(message.firmware);
    }
    if (message.bluetooth !== 0) {
      obj.bluetooth = Math.round(message.bluetooth);
    }
    if (message.protocol !== 0) {
      obj.protocol = Math.round(message.protocol);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Version>, I>>(base?: I): Version {
    return Version.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Version>, I>>(object: I): Version {
    const message = createBaseVersion();
    message.hardware = object.hardware ?? 0;
    message.firmware = object.firmware ?? 0;
    message.bluetooth = object.bluetooth ?? 0;
    message.protocol = object.protocol ?? 0;
    return message;
  },
};

function createBaseLimits(): Limits {
  return { pointsMax: 0, imageMax: 0 };
}

export const Limits: MessageFns<Limits> = {
  encode(message: Limits, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pointsMax !== 0) {
      writer.uint32(8).uint32(message.pointsMax);
    }
    if (message.imageMax !== 0) {
      writer.uint32(16).uint32(message.imageMax);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Limits {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLimits();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.pointsMax = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.imageMax = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Limits {
    return {
      pointsMax: isSet(object.pointsMax) ? globalThis.Number(object.pointsMax) : 0,
      imageMax: isSet(object.imageMax) ? globalThis.Number(object.imageMax) : 0,
    };
  },

  toJSON(message: Limits): unknown {
    const obj: any = {};
    if (message.pointsMax !== 0) {
      obj.pointsMax = Math.round(message.pointsMax);
    }
    if (message.imageMax !== 0) {
      obj.imageMax = Math.round(message.imageMax);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Limits>, I>>(base?: I): Limits {
    return Limits.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Limits>, I>>(object: I): Limits {
    const message = createBaseLimits();
    message.pointsMax = object.pointsMax ?? 0;
    message.imageMax = object.imageMax ?? 0;
    return message;
  },
};

function createBaseDevMessage(): DevMessage {
  return {
    uid: new Uint8Array(0),
    serialNumber: 0,
    version: undefined,
    limits: undefined,
    state: undefined,
    statistics: undefined,
    errorCode: 0,
    appMessage: undefined,
    durationMs: 0,
    impedanceResult: undefined,
  };
}

export const DevMessage: MessageFns<DevMessage> = {
  encode(message: DevMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.uid.length !== 0) {
      writer.uint32(10).bytes(message.uid);
    }
    if (message.serialNumber !== 0) {
      writer.uint32(16).uint32(message.serialNumber);
    }
    if (message.version !== undefined) {
      Version.encode(message.version, writer.uint32(26).fork()).join();
    }
    if (message.limits !== undefined) {
      Limits.encode(message.limits, writer.uint32(34).fork()).join();
    }
    if (message.state !== undefined) {
      State.encode(message.state, writer.uint32(42).fork()).join();
    }
    if (message.statistics !== undefined) {
      Statistics.encode(message.statistics, writer.uint32(50).fork()).join();
    }
    if (message.errorCode !== 0) {
      writer.uint32(56).uint32(message.errorCode);
    }
    if (message.appMessage !== undefined) {
      AppMessage.encode(message.appMessage, writer.uint32(66).fork()).join();
    }
    if (message.durationMs !== 0) {
      writer.uint32(72).uint32(message.durationMs);
    }
    if (message.impedanceResult !== undefined) {
      ImpedanceResult.encode(message.impedanceResult, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DevMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDevMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.uid = reader.bytes();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.serialNumber = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.version = Version.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.limits = Limits.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.state = State.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.statistics = Statistics.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.errorCode = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.appMessage = AppMessage.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.durationMs = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.impedanceResult = ImpedanceResult.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DevMessage {
    return {
      uid: isSet(object.uid) ? bytesFromBase64(object.uid) : new Uint8Array(0),
      serialNumber: isSet(object.serialNumber) ? globalThis.Number(object.serialNumber) : 0,
      version: isSet(object.version) ? Version.fromJSON(object.version) : undefined,
      limits: isSet(object.limits) ? Limits.fromJSON(object.limits) : undefined,
      state: isSet(object.state) ? State.fromJSON(object.state) : undefined,
      statistics: isSet(object.statistics) ? Statistics.fromJSON(object.statistics) : undefined,
      errorCode: isSet(object.errorCode) ? globalThis.Number(object.errorCode) : 0,
      appMessage: isSet(object.appMessage) ? AppMessage.fromJSON(object.appMessage) : undefined,
      durationMs: isSet(object.durationMs) ? globalThis.Number(object.durationMs) : 0,
      impedanceResult: isSet(object.impedanceResult) ? ImpedanceResult.fromJSON(object.impedanceResult) : undefined,
    };
  },

  toJSON(message: DevMessage): unknown {
    const obj: any = {};
    if (message.uid.length !== 0) {
      obj.uid = base64FromBytes(message.uid);
    }
    if (message.serialNumber !== 0) {
      obj.serialNumber = Math.round(message.serialNumber);
    }
    if (message.version !== undefined) {
      obj.version = Version.toJSON(message.version);
    }
    if (message.limits !== undefined) {
      obj.limits = Limits.toJSON(message.limits);
    }
    if (message.state !== undefined) {
      obj.state = State.toJSON(message.state);
    }
    if (message.statistics !== undefined) {
      obj.statistics = Statistics.toJSON(message.statistics);
    }
    if (message.errorCode !== 0) {
      obj.errorCode = Math.round(message.errorCode);
    }
    if (message.appMessage !== undefined) {
      obj.appMessage = AppMessage.toJSON(message.appMessage);
    }
    if (message.durationMs !== 0) {
      obj.durationMs = Math.round(message.durationMs);
    }
    if (message.impedanceResult !== undefined) {
      obj.impedanceResult = ImpedanceResult.toJSON(message.impedanceResult);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DevMessage>, I>>(base?: I): DevMessage {
    return DevMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DevMessage>, I>>(object: I): DevMessage {
    const message = createBaseDevMessage();
    message.uid = object.uid ?? new Uint8Array(0);
    message.serialNumber = object.serialNumber ?? 0;
    message.version = (object.version !== undefined && object.version !== null)
      ? Version.fromPartial(object.version)
      : undefined;
    message.limits = (object.limits !== undefined && object.limits !== null)
      ? Limits.fromPartial(object.limits)
      : undefined;
    message.state = (object.state !== undefined && object.state !== null) ? State.fromPartial(object.state) : undefined;
    message.statistics = (object.statistics !== undefined && object.statistics !== null)
      ? Statistics.fromPartial(object.statistics)
      : undefined;
    message.errorCode = object.errorCode ?? 0;
    message.appMessage = (object.appMessage !== undefined && object.appMessage !== null)
      ? AppMessage.fromPartial(object.appMessage)
      : undefined;
    message.durationMs = object.durationMs ?? 0;
    message.impedanceResult = (object.impedanceResult !== undefined && object.impedanceResult !== null)
      ? ImpedanceResult.fromPartial(object.impedanceResult)
      : undefined;
    return message;
  },
};

function bytesFromBase64(b64: string): Uint8Array {
  const bin = globalThis.atob(b64);
  const arr = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; ++i) {
    arr[i] = bin.charCodeAt(i);
  }
  return arr;
}

function base64FromBytes(arr: Uint8Array): string {
  const bin: string[] = [];
  arr.forEach((byte) => {
    bin.push(globalThis.String.fromCharCode(byte));
  });
  return globalThis.btoa(bin.join(""));
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | bigint | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
